import cn from "classnames";
import { useState, useRef, forwardRef, useImperativeHandle } from "react";
import { usePopper } from "react-popper";
import { useClickAway } from "react-use";

import { useMediaQuery } from "@hooks/useMediaQuery";
import SearchPassengersMobile from "@modals/SearchPassengersMobile/SearchPassengersMobile";

import Passengers from "../Passengers/Passengers";

import s from "./PassengersField.module.scss";

const PassengersField = forwardRef(
  ({ className, triggerElement, popperContentProps, modalProps }, ref) => {
    const { isMobile } = useMediaQuery();
    const [isPopperOpen, setIsPopperOpen] = useState(false);

    const elementRef = useRef(null);
    const popperRef = useRef(null);
    const [popperElement, setPopperElement] = useState(null);

    const popper = usePopper(elementRef.current, popperElement, {
      placement: "bottom-start",
    });

    const closePopper = () => {
      setIsPopperOpen(false);
    };

    const handleButtonClick = () => {
      setIsPopperOpen(!isPopperOpen);
    };

    useImperativeHandle(ref, () => ({
      openPopper: () => {
        setIsPopperOpen(true);
      },
    }));

    useClickAway(popperRef, () => {
      if (isPopperOpen) {
        closePopper();
      }
    });

    return (
      <div className={cn(s.field, className)}>
        {isMobile && modalProps.isOpen && (
          <SearchPassengersMobile {...modalProps} />
        )}
        <div
          ref={elementRef}
          onClick={handleButtonClick}
          // onMouseDown={(e) => e.preventDefault()}
          className={s.element}
        >
          {triggerElement}
        </div>
        {isPopperOpen && !isMobile && (
          <div
            ref={(node) => {
              setPopperElement(node);
              popperRef.current = node;
            }}
            style={popper.styles.popper}
            {...popper.attributes.popper}
          >
            <Passengers {...popperContentProps} />
          </div>
        )}
      </div>
    );
  },
);

PassengersField.displayName = "PassengersField";

export default PassengersField;
